import React from 'react'
import ListItemAccount from 'components/atoms/ListItemAccount'
import VStack from 'components/atoms/stack/VStack'
import { storeKeys } from 'services/store/keys'

const AccountList = ({ accounts, ...rowProps }) => {
	const list = Object.values( accounts );
	if( list.length === 0 ) return null;

	return (
		<VStack space={ 8 }>
			{ list.map( account => {
				return (
					<ListItemAccount
						key={ account[ storeKeys.ACCOUNT_IDENTIFIER ] }
						account={ account }
						{ ...rowProps }
					/>
				);
			} ) }
		</VStack>
	);
};

export default React.memo( AccountList );
